import type { PaginationQuery } from '../../../types/pagination';
import { appendPaginationQuery } from '../../../types/pagination';
import type { ApiClient } from '../client';
import type { AllocateHostelBedRequest, AllocateHostelBedResponse, CreateHostelRoomRequest, CreateHostelRoomResponse, CreateMessBillRequest, CreateMessBillResponse, ListHostelAllocationsQuery, ListHostelAllocationsResponse, ListHostelAttendanceQuery, ListHostelAttendanceResponse, ListHostelRoomsResponse, ListMessBillsQuery, ListMessBillsResponse, MarkHostelAttendanceRequest, MarkHostelAttendanceResponse } from '../types';

export function bindHostel(client: ApiClient) {
  return {
async listHostelRooms() {
    return client.request<ListHostelRoomsResponse>('/hostel/rooms');
  },

async createHostelRoom(body: CreateHostelRoomRequest) {
    return client.request<CreateHostelRoomResponse>('/hostel/rooms', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listHostelAllocations(params?: ListHostelAllocationsQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    if (params?.student_id) qs.append('student_id', params.student_id);
    const query = qs.toString();
    return client.request<ListHostelAllocationsResponse>(
      query ? `/hostel/allocations?${query}` : '/hostel/allocations'
    );
  },

async allocateHostelBed(body: AllocateHostelBedRequest) {
    return client.request<AllocateHostelBedResponse>('/hostel/allocations', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listHostelAttendance(params?: ListHostelAttendanceQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    if (params?.student_id) qs.append('student_id', params.student_id);
    const query = qs.toString();
    return client.request<ListHostelAttendanceResponse>(
      query ? `/hostel/attendance?${query}` : '/hostel/attendance'
    );
  },

async markHostelAttendance(body: MarkHostelAttendanceRequest) {
    return client.request<MarkHostelAttendanceResponse>('/hostel/attendance', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listMessBills(params?: ListMessBillsQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    if (params?.student_id) qs.append('student_id', params.student_id);
    if (params?.month) qs.append('month', params.month);
    const query = qs.toString();
    return client.request<ListMessBillsResponse>(
      query ? `/hostel/mess-bills?${query}` : '/hostel/mess-bills'
    );
  },

async createMessBill(body: CreateMessBillRequest) {
    return client.request<CreateMessBillResponse>('/hostel/mess-bills', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }
  };
}
